import moment from "moment";
import { Match } from "../types/Match";

export const getNameOfCurrentDay = () => {
  return moment(Date()).format("dddd");
};

export const getNextFiveDays = () => {
  let daysArray = [];
  for (let i = 0; i < 5; i++) {
    daysArray.push(
      moment(Date())
        .add(i + 1, "days")
        .format("dddd")
    );
  }
  return daysArray;
};

function parseUtcDateTime(dateString: string): Date | null {
  if (!dateString) return null;
  const hasZone = /[zZ]|[+-]\d{2}:?\d{2}$/.test(dateString);
  const parsed = new Date(hasZone ? dateString : `${dateString}Z`);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

function toLocalDateKey(date: Date): string {
  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, "0");
  const day = `${date.getDate()}`.padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function getDateKeyForOffsetFromToday(dayOffset: number): string {
  const date = new Date();
  date.setHours(0, 0, 0, 0);
  date.setDate(date.getDate() + dayOffset);
  return toLocalDateKey(date);
}

export function getMatchLocalDateKey(match?: Match): string {
  const kickoff = parseUtcDateTime(match?.kickOffTime?.dateTime ?? "");
  return kickoff ? toLocalDateKey(kickoff) : "";
}

export function getLocalTimeFromDate(dateString: string): string {
  const date = parseUtcDateTime(dateString);
  if (!date) return "";
  const hours = date.getHours().toLocaleString().padStart(2, "0");
  const minutes = date.getMinutes().toLocaleString().padStart(2, "0");
  return `${hours}:${minutes}`;
}

// Localized "napisano X temu" for AI commentary timestamps. Parses the backend
// UTC time and converts to local; uses a per-instance Polish locale so the
// global moment locale (day names elsewhere) is unaffected.
export function getRelativeTimePl(dateString: string): string {
  return `posted ${moment.utc(dateString).local().locale("pl").fromNow()}`;
}

export function getDateFromDate(dateString: string): string {
  const date = parseUtcDateTime(dateString);
  if (!date) return "";
  return date.toLocaleDateString([], {
    day: "2-digit",
    month: "short",
  });
}

export { parseUtcDateTime };

